var _module = require('../../components/module.js');
var config = require('config');
var moment = require('moment');
var simpleCypher = require('../../../libs/simple-cypher');
var _ = require('lodash');

require('angular-ui-router');
require('../user');
require('../utils');

_module.requires.push('ui.router');

_module.service('feedUtils', [
    '$log',
    '$filter',
    '$window',
    '$state',
    '$user',
    '$http',
    '$utils',
    '$location',

    function feedUtils($log, $filter, $window, $state, $user, $http, $utils, $location) {
        return {
            getUserId: function () {
                return ($user.account_type !== 'guest')
                    ? $user.id
                    : ($utils.parseAuthQueryParam())
                        ? $utils.parseAuthQueryParam()['userId']
                        : null;
            },

            getListingChangelog: function (skipId, skipCreatedAt) {
                var paramsObj = null;
                var _this = this;

                if(skipId && skipCreatedAt) {
                    paramsObj = {
                        skipListingChangelogId: skipId,
                        skipCreatedAt: skipCreatedAt
                    };
                }

                var userId = _this.getUserId();

                return $http.get('/v1/users/' + userId + '/listingchangelog', {params: paramsObj});
            },

            getRecentlySoldLog: function (pageNum) {
                var userId = this.getUserId();
                var paramsObj = {};
                var limit = 20;

                if(typeof pageNum !== 'undefined' && !isNaN(pageNum)){
                    paramsObj.skip = limit * (parseInt(pageNum, 10) - 1);
                    paramsObj.limit = limit;
                }

                return $http.get('/v1/users/' + userId + '/recentlysoldlog', {params: paramsObj});
            },

            getChangeType: function (changelogItem) {
                if(changelogItem.type === 'new') {
                    return 'just_listed';
                } else if(changelogItem.type === 'sold') {
                    return 'recently_sold';
                } else{
                    if(_.has(changelogItem, 'meta.changes.price')){
                        return 'price_change';
                    }else if(_.has(changelogItem, 'meta.changes.open_houses')){
                        return 'open_house_change';
                    }else{
                        return 'listing_status_change';
                    }
                }
            },

            getDetailViewUrl: function (listing) {
                if(listing && listing.listingId && listing.listing_source) {
                    var params = {
                        listingId: simpleCypher.encode(listing.listing_source, listing.listingId),
                        address: $filter('slug')(listing.meta.FormattedAddress || '')
                    };

                    if( listing.searchFilterId ){
                        params.filter = listing.searchFilterId;
                    }

                    if($location.search() && $location.search().a){
                        params.a = $location.search().a;
                    }

                    return $state.href('viewlisting', params);
                }else{
                    return null;
                }
            },

            filterOpenHouses: function (obj) {
                if(_.has(obj, 'meta.OpenHouses')){
                    var openhouses = obj.meta.OpenHouses;
                    if(openhouses && angular.isArray(openhouses)){
                        openhouses = openhouses.filter(function (oh) {
                            return moment(oh.StartTimeISO).isAfter();
                        });
                    }

                    obj.meta.OpenHouses = openhouses;
                }

                return obj;
            },

            processChangelog: function (changelog, oldChangelog, groupByKey) {
                var _this = this;
                var cl = changelog;
                var ocl = oldChangelog || [];
                var ncl = ocl;


                for(var i=0; i<cl.length; i++) {
                    var changeType = _this.getChangeType(cl[i]);
                    var obj = JSON.parse(JSON.stringify(cl[i]));
                    obj.template_type = changeType;
                    obj.view_listing_link = _this.getDetailViewUrl(obj);
                    obj = _this.filterOpenHouses(obj);

                    if(angular.isUndefined(groupByKey)) {
                        groupByKey = 'createdAt';
                    }
                    var group = moment(cl[i][groupByKey], 'YYYY-M-DD').toISOString();
                    var found = _.findIndex(ocl, {group: group});

                    if(group){
                        if(found > -1 && ncl[found] && ncl[found].hasOwnProperty('cards')) {
                            var foundCard = _.findIndex(ncl[found]['cards'], {id: obj.id});
                            if(foundCard > -1) {
                                //ensures unique posts
                                ncl[found]['cards'].splice(foundCard, 1);
                            }
                            ncl[found]['cards'].push(obj);
                        }else{
                            var grpObj = {
                                group: group,
                                cards: [obj]
                            };
                            ncl.push(grpObj);
                        }
                    }else{
                        $log.debug('Couldn\'t assign group to item:', cl[i]);
                    }
                }

                var getNumFromDate = function (d) {
                    if(d && !isNaN(d.replace(/-/g, ''))){
                        return parseInt(d.replace(/-/g, ''), 10);
                    }else{
                        return null;
                    }
                };

                var sortedNcl = ncl.sort(function (a,b) {
                    return getNumFromDate(b.group) - getNumFromDate(a.group);
                });

                $log.debug('New Changelog', sortedNcl);

                return sortedNcl;
            },

            getUserMatchScoreClassPreference: function () {
                var r = ['great', 'good'];
                if ( $user &&
                    _.has($user, 'settings.alerts.match_score_classes') &&
                    angular.isArray($user.settings.alerts.match_score_classes) &&
                    $user.settings.alerts.match_score_classes.length ) {

                    r = $user.settings.alerts.match_score_classes;
                }

                return r;
            },

            isFeedCandidate: function (data) {
                var _this = this;
                if(!data) {
                    return false;
                }else {
                    var matchScoreClassFilter = _this.getUserMatchScoreClassPreference();
                    var r = true;

                    // is invalid if new value of the `active` key is false
                    if(_.has(data, 'meta.changes.active.new') &&
                        String(data.meta.changes.active.new) === 'false') {
                        r = false;
                    }

                    // is invalid if new value of the `open_houses` key is ''
                    if(_.has(data, 'meta.changes.open_houses.new') &&
                        String(data.meta.changes.open_houses.new) === '') {
                        r = false;
                    }

                    // is invalid if new value of the `match_score_class`
                    //isn't within the user's match_score_class preferences
                    if(_.has(data, 'meta.match_score_class') &&
                        data.meta.match_score_class &&
                        matchScoreClassFilter.indexOf(data.meta.match_score_class) < 0) {
                        r = false;
                    }

                    return r;
                }
            }
        };
    }
]);
